import projection from '../generated/pw2204f1.json'; import { AcceptanceManifest } from '../types';
export const pw2204f1AcceptanceManifest = projection as AcceptanceManifest;
